<template>
	<div class="selected-missions-container">
		<SelectedMissionItem v-for="mission in missions" :key="mission.id" :mission_id="mission.id"
			@goToMissionPosition="handleGoToMissionPosition" @close="deleteMission"
			@changing_data="loading_mission = $event" />
	</div>

	<data-dialog v-model:dialog="dialog" @close="dialog = false"
		@accept="(interval, recordsType) => addMission(interval, recordsType)" :active_mission="active_mission" />
	<charge-dialog :loading_mission="loading_mission" :chargeText="chargeText" />
</template>

<style lang="stylus" scoped>
	@import("../../assets/css/generalColors.styl")
	.selected-missions-container
		display: flex;
		width: 100%;
		flex-wrap: wrap;
		justify-content: center;
		position absolute
		bottom 70px
		z-index 999
</style>

<script setup>
import SelectedMissionItem from '@/components/selectedMissions/SelectedMissionItem.vue';
import { ref, watch } from 'vue';
import axios from 'axios';
import DataDialog from './DataDialog.vue';
import ChargeDialog from './ChargeDialog.vue';
import { usePlayMissionStore } from '@/store/playMission';
import { storeToRefs } from 'pinia';
import { useNotificationStore } from '@/store/notificationStore';
import { tm_url } from '@/config/api_url';
const props = defineProps({
	newMission: Object
})

const missionToAdd = ref();

watch(() => props.newMission, (newValue) => {
	if (newValue != null) {
		missionToAdd.value = newValue;
		active_mission.value = newValue.active_mission === 1;
		dialog.value = true;
	}
});

const emits = defineEmits(['deleteMission', 'goToMissionPosition', 'newMission', 'closeVehicleInfo'])
const playMissionStore = usePlayMissionStore();
const { missions, chargeText, loading_mission } = storeToRefs(playMissionStore);
const missionUpdateIntervalMap = new Map();
const active_mission = ref(false);

const dialog = ref(false);

window.addEventListener('beforeunload', (event) => {
	missions.value.forEach(value => {
		const body = {
			user: localStorage.getItem('user'),
			mission_id: value.id,
			session_id: playMissionStore.session_id
		}
		liveMissionUnsubscribe(body);
	})
	return '';
});

const handleGoToMissionPosition = (mission, vehicle_id) => {
	emits('goToMissionPosition', mission, vehicle_id);
}


const liveMissionUnsubscribe = async (body) => {
	await axios.post(`${tm_url}/unsubscribe`, body);
}

const liveMissionSubscribe = async (body) => {
	try {
		const response = await axios.post(`${tm_url}/subscribe`, body)
		if (response.status === 200) {
			playMissionStore.session_id = response.data;
			body.session_id = response.data;
			return response.status;
		} else if (response.status === 409) {
			await liveMissionUnsubscribe(body);
			return await liveMissionSubscribe(body);
		}
		return response.status;
	} catch (error) {
		if (error.response.status === 409) {
			useNotificationStore().setNotification('Mission is already playing',
				'The mission is already playing with this user. If you have open sessions, close them and try again. Otherwise, you will not receive live data.',
				'mdi-warning',
				'orange');
		}
		return error.response.status;
	}

}


const addMission = async (interval, recordsType) => {

	dialog.value = false;
	loading_mission.value = true;
	const result = await playMissionStore.startPlayMission(
		missionToAdd.value,
		interval,
		recordsType,
		missionToAdd.value.active_mission
	);
	loading_mission.value = false;

	if (missionToAdd.value.active_mission && result) {
		const body = {
			user: localStorage.getItem('user'),
			mission_id: missionToAdd.value.id
		}
		const status = await liveMissionSubscribe(body);

		if (status === 200) {

			body['session_id'] = playMissionStore.session_id;

			const missionUpdateInterval = setInterval(async () => {
				try {
					const response = await axios.get(`${tm_url}/getData`, {
						params: { ...body }
					});
					let dataArray = response.data;
					dataArray.forEach(value => {
						if (value.records != null && value.records != undefined) {
							playMissionStore.addRecordToLiveMission(missionToAdd.value.id, value.records, value.vehicle_id);
						}
						if (value.waypoints != null && value.waypoints != undefined) {
							playMissionStore.addWaypointsToLiveMission(missionToAdd.value.id, value.waypoints, value.vehicle_id);
						}
					})

				} catch (error) {
					if (error.response?.status === 404) {
						liveMissionSubscribe(body)
					}
				}

			}, 3000);
			missionUpdateIntervalMap.set(missionToAdd.value.id, missionUpdateInterval)

		}

	}


}

const deleteMission = (mission) => {
	if (!mission || !mission.id) {
		console.warn('Mission inválida en deleteMission');
		return;
	}

	if (mission.active_mission) {
		const body = {
			user: localStorage.getItem('user'),
			mission_id: mission.id,
			session_id: playMissionStore.session_id
		};

		liveMissionUnsubscribe(body);
		const interval = missionUpdateIntervalMap.get(mission.id);
		console.log(interval)
		if (interval) clearInterval(interval);
		missionUpdateIntervalMap.delete(mission.id);
	}

	emits('closeVehicleInfo');
	chargeText.value = "Closing mission " + mission.name;
	loading_mission.value = true;
	try {
		playMissionStore.closeMission(mission.id);
	} catch (error) {
		console.error(error);
	}



};

</script>